import { find, pick, contains, map } from 'underscore';

const defaultMaxLength = 8;

/**
 * Default countdown language is English.
 */
// const defaultLanguageIndex = 2;
let supportedLanguages = null;

/**
 * Languages supported for countdown.
 * The ones that have "locale" property are also supported for on-the-fly translation.
 * @param {Object} i18n - i18n
 * @param {Object} permissions - UI permissions
 * @returns {Array} supported langauges with format of [{codes, displayName, maxLength}]
 */
const intializeAndGetSupportedLanguages = (i18n, permissions = {}) => {
  if (!supportedLanguages) {
    supportedLanguages = [
      {
        codes: ['da'],
        locale: 'da',
        displayName: i18n.getString(_TL_('Danish')),
        maxLength: defaultMaxLength,
      },
      {
        codes: ['nl'],
        locale: 'nl',
        displayName: i18n.getString(_TL_('Dutch')),
        maxLength: defaultMaxLength,
      },
      {
        codes: ['en-us', 'en-au', 'en-gb'],
        locale: 'en-us',
        displayName: i18n.getString(_TL_('English')),
        maxLength: defaultMaxLength,
      },
      {
        codes: ['fi'],
        locale: 'fi',
        displayName: i18n.getString(_TL_('Finnish')),
        maxLength: defaultMaxLength,
      },
      {
        codes: ['fr'],
        locale: 'fr',
        displayName: i18n.getString(_TL_('French')),
        maxLength: defaultMaxLength,
      },
      {
        codes: ['de'],
        locale: 'de',
        displayName: i18n.getString(_TL_('German')),
        maxLength: defaultMaxLength,
      },
      {
        codes: ['it'],
        locale: 'it',
        displayName: i18n.getString(_TL_('Italian')),
        maxLength: defaultMaxLength,
      },
      {
        codes: ['no'],
        displayName: i18n.getString(_TL_('Norwegian')),
        maxLength: defaultMaxLength,
      },
      {
        codes: ['pt-br', 'pt-pt'],
        locale: 'pt-br',
        displayName: i18n.getString(_TL_('Portuguese')),
        maxLength: defaultMaxLength,
      },
      {
        codes: ['es', 'es-419'],
        locale: 'es',
        displayName: i18n.getString(_TL_('Spanish')),
        maxLength: defaultMaxLength,
      },
      {
        codes: ['sv'],
        locale: 'sv',
        displayName: i18n.getString(_TL_('Swedish')),
        maxLength: defaultMaxLength,
      },
      {
        codes: ['zh-hk', 'zh-tw'],
        locale: 'zh-hant',
        displayName: i18n.getString(_TL_('Traditional Chinese')),
        maxLength: defaultMaxLength,
      },
    ];
    if (permissions.IsAdsGlobalizationPhase1Enabled) {
      supportedLanguages = supportedLanguages.concat([
        {
          codes: ['el'],
          displayName: i18n.getString(_TL_('Greek')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['pl'],
          locale: 'pl',
          displayName: i18n.getString(_TL_('Polish')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['bg'],
          displayName: i18n.getString(_TL_('Bulgarian')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['cs'],
          displayName: i18n.getString(_TL_('Czech')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['et'],
          displayName: i18n.getString(_TL_('Estonian')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['hr'],
          displayName: i18n.getString(_TL_('Croatian')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['hu'],
          displayName: i18n.getString(_TL_('Hungarian')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['lt'],
          displayName: i18n.getString(_TL_('Lithuanian')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['lv'],
          displayName: i18n.getString(_TL_('Latvian')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['mt'],
          displayName: i18n.getString(_TL_('Maltese')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['ro'],
          displayName: i18n.getString(_TL_('Romanian')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['sk'],
          displayName: i18n.getString(_TL_('Slovak')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['sl'],
          displayName: i18n.getString(_TL_('Slovenian')),
          maxLength: defaultMaxLength,
        },
      ]);
    }
    if (permissions.IsAdsGlobalizationPhase2Enabled) {
      supportedLanguages = supportedLanguages.concat([
        {
          codes: ['tr'],
          displayName: i18n.getString(_TL_('Turkish')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['sr'],
          displayName: i18n.getString(_TL_('Serbian')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['bs'],
          displayName: i18n.getString(_TL_('Bosnian')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['sq'],
          displayName: i18n.getString(_TL_('Albanian')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['mk'],
          displayName: i18n.getString(_TL_('Macedonian')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['is'],
          displayName: i18n.getString(_TL_('Icelandic')),
          maxLength: defaultMaxLength,
        },
      ]);
    }
    if (permissions.IsAdsGlobalizationPhase6Enabled) {
      supportedLanguages = supportedLanguages.concat([
        {
          codes: ['ar'],
          locale: 'ar',
          displayName: i18n.getString(_TL_('Arabic')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['iw'],
          displayName: i18n.getString(_TL_('Hebrew')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['ru'],
          displayName: i18n.getString(_TL_('Russian')),
          maxLength: defaultMaxLength,
        },
      ]);
    }
    if (permissions.IsAdsGlobalizationPhase2JapanEnabled) {
      supportedLanguages = supportedLanguages.concat([
        {
          codes: ['ja'],
          locale: 'ja',
          displayName: i18n.getString(_TL_('Japanese')),
          maxLength: defaultMaxLength,
        },
      ]);
    }
    if (permissions.dynamic && permissions.dynamic.AdsGlobalizationPhase9DSA) {
      supportedLanguages = supportedLanguages.concat([
        {
          codes: ['hi'],
          locale: 'hi',
          displayName: i18n.getString(_TL_('Hindi')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['ms'],
          displayName: i18n.getString(_TL_('Malay')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['th'],
          locale: 'th',
          displayName: i18n.getString(_TL_('Thai')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['in'],
          locale: 'in',
          displayName: i18n.getString(_TL_('Indonesian')),
          maxLength: defaultMaxLength,
        },
        {
          codes: ['tl'],
          displayName: i18n.getString(_TL_('Tagalog')),
          maxLength: defaultMaxLength,
        },
      ]);
    }
    if (permissions.IsAdsGlobalizationPhase9VIEnabled) {
      supportedLanguages = supportedLanguages.concat([
        {
          codes: ['vi'],
          displayName: i18n.getString(_TL_('Vietnamese')),
          maxLength: defaultMaxLength,
        },
      ]);
    }
    if (permissions.IsDomesticSimplifiedChineseEnabled) {
      supportedLanguages = [
        {
          codes: ['zh-CN'],
          locale: 'zh-hans',
          displayName: i18n.getString(_TL_('Simplified Chinese')),
          maxLength: defaultMaxLength,
        },
      ];
    }
  }

  return supportedLanguages;
};

export const languageParseMode = {
  ForPreview: 0,
  ForEditor: 1,
  ForCharacterCount: 2,
};

/**
 * Gets default language for count down
 * @param {Object} i18n - i18n
 * @param {Object} permissions - UI permissions
 * @returns {Object} a language construct that holds locale and display name
 */
export function getDefaultLanguage(i18n, permissions) {
  const defaultLanguageIndex = permissions.IsDomesticSimplifiedChineseEnabled ? 0 : 2; // Simplified Chinese : English
  const language = intializeAndGetSupportedLanguages(i18n, permissions)[defaultLanguageIndex];

  return pick(language, 'locale', 'displayName', 'maxLength');
}

/**
 * Gets the appropriate language object for given language code
 * @param {string} code - language code
 * @param {int} parseMode - flag for whether we are parsing for preview, editor or char count
 * @param {Object} i18n - i18n
 * @param {Object} permissions - UI permissions
 * @returns {Object} a language construct that holds locale and display name
 * For preview:
 * - language is not supported => null
 * - language is supported but not for translation => default
 * For editor:
 * - language is not supported => default
 * - language is supported but not for translation => language
 * For character count:
 * - language is not supported => null
 * - language is supported but not for translation => language
 * For all:
 * - language is undefined => default
 * - language is fully supported => language
 */
export function getLanguage(code, parseMode, i18n, permissions) {
  let language = getDefaultLanguage(i18n, permissions);

  if (code) {
    const match = find(
      intializeAndGetSupportedLanguages(i18n, permissions),
      lang => contains(lang.codes, code.toLowerCase())
    );

    if (match && match.locale) {
      language = match;
    } else if (match) {
      language = parseMode === languageParseMode.ForPreview ? language : match;
    } else {
      language = parseMode === languageParseMode.ForEditor ? language : null;
    }
  }

  return language ? pick(language, 'locale', 'displayName', 'maxLength') : null;
}

/**
 * Gets all supported language display names
 * @param {Object} i18n - i18n
 * @param {Object} permissions - UI permissions
 * @returns {array} display names
 */
export function getSupportedLanguages(i18n, permissions) {
  return map(
    intializeAndGetSupportedLanguages(i18n, permissions),
    lang => lang.displayName
  );
}

/**
 * Gets the default language code for given display name
 * @param {string} displayName - display name
 * @param {Object} i18n - i18n
 * @param {Object} permissions - UI permissions
 * @returns {string} language code
 */
export function getLanguageCode(displayName, i18n, permissions) {
  const match = find(
    intializeAndGetSupportedLanguages(i18n, permissions),
    lang => lang.displayName === displayName
  );

  return match ? match.codes[0] : null;
}
